import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { KmsService } from '../../../kms.service';
import { SwTabService } from '../../../../../librarys/serves/public/sw-tab.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { DictionaryService } from '../../../../../librarys/serves/public/dictionary.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { EditDatasourceComponent } from '../../../components/edit-datasource/edit-datasource.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
declare var $;
@Component({
    selector: 'app-instance-view',
    templateUrl: './instance-view.component.html',
    styleUrls: ['./instance-view.component.css']
})
export class InstanceViewComponent implements OnInit {
    // 输入参数：
    // 实体id
    @Input() instanceId:string = '';
    // 是否展示查看质检记录模块
    @Input() showVerifyRecord:boolean = true;
    // 路由参数
    params = {
        instanceId: '',  // 实体id(用于切换tab导航和新增其他信息时的判断)
        conceptId: '',
        instanceName: '',
        conceptName: '',
    };
    // 是否显示加载中
    isLoading = false;
    // 实体基本信息内容
    instanceDetailData: any;
    // 实体标签信息内容
    selectedTags = [];
    // 实体表单结构信息
    baseInfoConfig = [];
    // 其它属性表单结构（如生平、流传、修复等）
    multipleAttribute = [];
    // 其它属性表单结构（如生平、流传、修复等）
    compositeAttributes = [];
    // tab菜单切换选中的菜单名称
    tabId = '001';
    // 是否展示底部按钮
    showFooterBtn:boolean = true;
    // 表单控件类型
    formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
    constructor(
        private tabServe: SwTabService,
        private create: SwCreateModalComponentService,
        private routeInfo: ActivatedRoute,
        private kmsService: KmsService,
        private dicService: DictionaryService,
        private message: SwMassageBoxService,
    ) { }

    ngOnInit() {
        if(!this.instanceId){
            // 获取路由参数
            this.routeInfo.queryParams.subscribe((data: Params) => {
                const params = JSON.parse(data['selectData']);
                if(params.instanceId){
                    this.params.instanceId = params.instanceId;
                    this.getInstanceById(params.instanceId);
                }
                if(params.tabId){
                    this.tabId = params.tabId;
                }
            });
        }
    }

    ngOnChanges(){
        if(this.instanceId){
            this.params.instanceId = this.instanceId;
            this.getInstanceById(this.instanceId);
            this.showFooterBtn = false;
        }
    }

    // tab菜单切换点击方法
    handleTabClick(id) {
        this.tabId = id;
    }

    // 根据实体ID查询实体详细信息
    getInstanceById(id) {
        this.kmsService.getInstanceById(id).subscribe(
            result => {
                if (result.code == 200) {
                    let datas = result.data;
                    this.params.conceptId = datas.conceptId;
                    this.params.conceptName = datas.conceptName;
                    this.instanceDetailData = datas;
                    if (datas.tags) {
                        this.selectedTags = datas.tags;
                    } else {
                        this.selectedTags = [];
                    }
                    this.params.instanceName = datas.instanceName;
                    this.getInstanceFormData(this.params.conceptId);
                }
            }
        )
    }

    // 根据概念id查询属性字段列表
    getInstanceFormData(id) {
        this.isLoading = true;
        this.kmsService.getAttributeForForm(id).subscribe(
            result => {
                this.isLoading = false;
                if (result.code == '200') {
                    // 渲染基本信息表格
                    // 获取著录信息配置
                    let commonAttributes = result.data.commonAttributes.sort(function(a,b){
                        return a.sortNum - b.sortNum
                    });
                    let datas = [];
                    commonAttributes.forEach(el => {
                        datas.push([el]);
                    });

                    // 获取复合属性信息配置
                    let datasItem = result.data.compositeAttributes;                   
                    let tabDatas = [
                        {attributeName: '著录信息', attributeId: '001', id: 'descriptInfo'}
                    ];
                    if (datasItem && datasItem.length > 0) {
                        datasItem.forEach(item => {
                            item.attributeName = $.trim(item.attributeName) + '信息'
                            item.id = 'otherInfo'
                            tabDatas.push(item);
                            this.compositeAttributes.push(item);
                        })
                    }
                    tabDatas.push(
                        {attributeName: '关系配置', attributeId: '002', id: 'relationInfo'},
                        {attributeName: '关联资源', attributeId: '003', id: 'resourceInfo'},
                    );
                    this.multipleAttribute = tabDatas;
                    // 当前实体详细包含的三元组数据内容
                    let triples = this.instanceDetailData.attrs;
                    datas.forEach((item, index) => {
                        let itemDatas = item[0];
                        let sourceObj:any = {};
                        itemDatas = JSON.parse(JSON.stringify(itemDatas));
                        if (triples && triples.length > 0) {
                            for (let i = 0; i < triples.length; i++) {
                                // 判断属性三元组中的属性id 与 当前属性的属性id是否相同
                                // 若是当前属性，则需要把属性值、数据来源等信息塞入到表单结构中
                                if (itemDatas.attributeId == triples[i].relationshipId) {
                                    // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                                    if (!itemDatas.uuid) {
                                        datas[index].splice(0, 1);
                                    }
                                    // 获取属性值节点id
                                    itemDatas.id = triples[i].id;

                                    // 下拉框类型
                                    if (itemDatas.fieldType === this.formControlTypes.dropBox && itemDatas.dictionryCode && triples[i].dictCode) {
                                        itemDatas.attributeChName = triples[i].dictCode;
                                        itemDatas['options'] = this.dicService.getDictionaryValueOrName(
                                            itemDatas.dictionryCode
                                        );
                                    } 

                                    // 树形下拉框类型
                                    if (itemDatas.fieldType === this.formControlTypes.treeSelect && itemDatas.dictionryCode && triples[i].dictCode) {
                                        itemDatas.attributeChName = triples[i].dictCode;
                                        itemDatas['options'] = this.dicService.getDictionaryTree(itemDatas.dictionryCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
                                        let options = JSON.parse(JSON.stringify(itemDatas['options']));
                                        itemDatas['options'].forEach(element => {
                                            let item = options.filter(el => el.id == element['pid']);
                                            element['pid'] = item.length>0 ? item[0].value : '0';
                                            element['parentId'] = element['pid'];
                                            element['id'] = element['value'];
                                        });
                                    } 

                                    // 行政区划
                                    if (itemDatas.fieldType === this.formControlTypes.administrativeDivision) {
                                        itemDatas.attributeChName = triples[i].dictCode;
                                    } 

                                    // 单选
                                    if(itemDatas.fieldType == this.formControlTypes.radio){
                                        itemDatas.attributeChName = triples[i].attributeValue;
                                        itemDatas['options'] = itemDatas['dictionryCode'].split('、');
                                        if(itemDatas['options'].length == 0){
                                            itemDatas['options'] = ['','']
                                        }
                                        if(itemDatas['options'].length == 1){
                                            itemDatas['options'].push('')
                                        }
                                    }
                                    
                                    // 短文本、现代时间、文本域、富文本框
                                    if(itemDatas.fieldType === this.formControlTypes.input || itemDatas.fieldType === this.formControlTypes.nowDate || itemDatas.fieldType === this.formControlTypes.textarea || itemDatas.fieldType === this.formControlTypes.richTextBox){
                                        itemDatas.attributeChName = triples[i].attributeValue;
                                    }

                                    // 地理位置  带备注信息和不带备注信息
                                    if (itemDatas.fieldType === this.formControlTypes.geoRemark || itemDatas.fieldType === this.formControlTypes.geo) {
                                        itemDatas.attributeChName = triples[i].attributeValue;
                                        itemDatas.attributeChNameOther = triples[i].remark == 'null' ? '' : triples[i].remark;
                                        itemDatas.geo = triples[i].dictCode;
                                    }
                                    // 时间日期  带备注信息和不带备注
                                    if (itemDatas.fieldType === this.formControlTypes.dateRemark || itemDatas.fieldType === this.formControlTypes.date) {
                                        itemDatas.attributeChNameOther = triples[i].attributeValue;
                                        itemDatas.attributeChName = triples[i].dictCode;
                                    }
                                    // // 长度、宽度、长宽单位
                                    // if (itemDatas.fieldType === this.formControlTypes.size) {
                                    //     itemDatas.attributeChName = triples[i].attributeValue;
                                    //     itemDatas.attributeChNameOther = triples[i].dictCode;
                                    // }
                                    // // 三维数据
                                    // if (itemDatas.fieldType === this.formControlTypes.threeDimension) {
                                    //     itemDatas.attributeChName = triples[i].attributeValue;
                                    //     itemDatas.attributeChNameOther = triples[i].dictCode;
                                    // }
                                    const sourceItem = {
                                        "uuid": triples[i].uuid,
                                        "materialId":triples[i].materialId,
                                        "sourceText":triples[i].sourceText,
                                        "sourceMaterial":triples[i].sourceMaterial,
                                        "pageNum":triples[i].pageNum,
                                        "relPageNum":triples[i].relPageNum,
                                        "datasource":triples[i].datasource
                                    }
                                    if(sourceObj[itemDatas.id]){
                                        sourceObj[itemDatas.id].sourceList.push(sourceItem);
                                    }else{
                                        sourceObj[itemDatas.id] = JSON.parse(JSON.stringify(itemDatas));
                                        sourceObj[itemDatas.id]['sourceList'] = [sourceItem]
                                    }
                                }
                            }
                        }
                        let keys = Object.keys(sourceObj);
                        if(keys.length>0){
                            datas[index] = [];
                            for(let i=0;i<keys.length;i++){
                                datas[index].push(sourceObj[keys[i]])
                            }
                        }
                    });
                    // 保存属性结构数据
                    this.baseInfoConfig = datas;
                } else {
                    this.message.waring(result.msg);
                }
            });
    }

    // 根据字典查看文字信息
    getDictionaryName(x, y) {
        if (x && y) {
            let yDatas: any;
            let datas = [];
            yDatas = y.split(',');
            for (let i = 0; i < x.length; i++) {
                for (let j = 0; j < yDatas.length; j++) {
                    if (x[i].id == yDatas[j]) {
                        datas.push(x[i].text)
                    }
                }
            }
            if (datas.toString()) {
                return datas.toString();
            } else {
                return '';
            }
        }else{
            return '';
        }
    }

    handleSourceEditClick(item) {
        const data = {
            state: 'view',
            sourceList: item.sourceList
        }
        this.create.createModal(EditDatasourceComponent, data);
    }

    // 页面关闭方法
    goBack() {
        this.tabServe.closeUrl('/kms/InstanceView', true);
        // this.tabServe.refurbis("/kms/InstanceQuery");
    }
}
